import { useEffect, useRef } from "react";
import { useTheme } from "next-themes";
import { useAuth } from "@/App";
import { useLocale } from "@/context/LocaleContext";

/** Apply saved account language/theme when a user session loads. */
export function UserPreferencesSync() {
  const { user } = useAuth();
  const { setLang } = useLocale();
  const { setTheme } = useTheme();
  const appliedForUserId = useRef(null);

  useEffect(() => {
    if (!user || user === false) {
      appliedForUserId.current = null;
      return;
    }
    if (appliedForUserId.current === user.id) return;
    appliedForUserId.current = user.id;
    if (user.preferred_lang) setLang(user.preferred_lang);
    if (user.preferred_theme) setTheme(user.preferred_theme);
  }, [user, setLang, setTheme]);

  return null;
}
